import p5 from 'p5';
import helper from '../helper';
import { IonPainter } from './IonPainter';
import { Ray } from './Ray';
import { Wall } from './Wall';

interface Position {
  x: number;
  y: number;
}

export class Particle {
  private _p5: IonPainter;
  private _position: p5.Vector;
  private _rays: Ray[];
  private _heading: number;
  private _rayRotation: number = 0;
  private _baseQuality: number = 255;
  private _maxAngle: number = 60;
  private _cutOffAngle: number = 0;

  constructor (P5: IonPainter, position: Position) {
    this._p5 = P5;
    this._position = this._p5.createVector(position.x, position.y);
    this._rays = [];
    this._heading = 0;

    for (this._rayRotation = -this._maxAngle; this._rayRotation <= this._maxAngle; this._rayRotation += .2) {
      let newQuality = 0;
      if (this._rayRotation <= -this._cutOffAngle || this._rayRotation >= this._cutOffAngle) {
        const scaled = helper.numbers.scaleValue(Math.abs(this._rayRotation) - this._cutOffAngle, {
          start: 0,
          end: this._maxAngle - this._cutOffAngle
        }, {
          start: 0,
          end: 100
        });
        const ratio = 1 - scaled / 100;
        newQuality = this._baseQuality * ratio;
      } else {
        newQuality = this._baseQuality;
      }
      this._rays.push(new Ray(this._p5, this._position, this._p5.radians(this._rayRotation), newQuality));
    }
  }

  public position (x: number, y: number): void {
    this._position.set(x, y);
  }

  public rotate (angle: number): void {
    this._heading += angle;
    let index = 0;
    for (this._rayRotation = -this._maxAngle; this._rayRotation <= this._maxAngle; this._rayRotation += .2) {
      this._rays[index].direction = p5.Vector.fromAngle(this._p5.radians(this._rayRotation) + this._heading);
      index++;
    }
  }

  public move (amount: number): void {
    const value = p5.Vector.fromAngle(this._heading);
    value.setMag(amount);
    this._position.add(value);
  }

  public look (boundrys: Wall[]): number[] {
    const scene = [];
    for (const ray of this._rays) {
      let closest = null;
      let record = Infinity;
      for (const boundry of boundrys) {
        const intersection = ray.intersects(boundry);
        if (intersection) {
          let distance = p5.Vector.dist(this._position, intersection);
          const a = ray.direction.heading() - this._heading;
          distance *= this._p5.cos(a);

          if (distance < record) {
            record = distance;
            closest = intersection;
          }
          record = Math.min(distance, record);
        }
      }
      if (closest) {
        this._p5.stroke(0, 255, 0, ray.quality);
        this._p5.line(this._position.x, this._position.y, closest.x, closest.y);
      }
      scene.push(record);
    }
    return scene;
  }

  public show (): void {
    this._p5.fill(255);
    this._p5.ellipse(this._position.x, this._position.y, 4);
    for (const ray of this._rays) {
      ray.show();
    }
  }
}
